import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useAdminCardBalance } from "@/hooks/use-queries";
import { formatAmount } from "@/lib/utils";
import { useAdminModals } from "@/zustand/store";
import { ColumnDef } from "@tanstack/react-table";
import { Trash2 } from "lucide-react";
const BalanceCell = ({ card }: { card: Card }) => {
  const { balance, isLoading } = useAdminCardBalance(card);
  if (isLoading) return <Skeleton className="h-4 w-12" />;
  return <div className="text-xs">${formatAmount(balance?.available)}</div>;
};

const NetworkCell = ({ card }: { card: Card }) => {
  const { network, isLoading } = useAdminCardBalance(card);
  if (isLoading) return <Skeleton className="h-4 w-12" />;
  return <div className="text-xs">{network}</div>;
};

export const cardColumns: ColumnDef<Card>[] = [
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => (
      <div className="text-xs text-[#161B33] capitalize">
        {row.original.firstName + " " + row.original.lastName}
      </div>
    ),
  },
  {
    header: "Cards Bal",
    cell: ({ row }) => <BalanceCell card={row.original} />,
  },
  {
    header: "Network",
    cell: ({ row }) => <NetworkCell card={row.original} />,
  },
  {
    header: "Type",
    cell: ({ row }) => {
      const isPlatinum = row.original.provider === "wsb";
      return (
        <span
          className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${
            isPlatinum
              ? "bg-[#F0E0AC]/20 text-[#DA69AE]"
              : "bg-[#b4eaff]/20 text-[#5649AD]"
          }`}
        >
          {isPlatinum ? "Platinum" : "Sapphire"}
        </span>
      );
    },
  },
  {
    header: "Card No",
    cell: ({ row }) => (
      <div className="text-xs text-[#001788]">****{row.original.last4}</div>
    ),
  },
  {
    header: "Status",
    cell: ({ row }) => {
      return <div className="text-xs">{row.original.status}</div>;
    },
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      // const { openModal } = useModalStore();
      return (
        <div className="flex items-center gap-4">
          <Button
            onClick={() => {
              useAdminModals.setState({
                freezeCardIsOpen: true,
                freezeCardData: row.original,
              });
            }}
            className="bg-primary-500 flex size-6 items-center justify-center rounded-full p-0"
          >
            <img
              src="/icons/freeze-light.svg"
              alt="freeze icon"
              className="size-4"
            />
          </Button>
          <Button
            onClick={() => {
              useAdminModals.setState({
                deleteCardIsOpen: true,
                deleteCardData: row.original,
              });
            }}
            className="flex size-6 items-center justify-center rounded-full bg-[#FF6E7A] p-0"
          >
            <Trash2 className="size-4" strokeWidth={1.5} />
          </Button>
        </div>
      );
    },
  },
];
